export default (parentStr, searchText) => {
  const res = new RegExp(`(${searchText})`, 'g')
  parentStr = parentStr.replace(res, `<span style='color:var(--m-success-normal);'>${searchText}</span>`)
  return parentStr
}
